import React from "react";
import PropTypes from "prop-types";

/**
 * An accessible on/off switch.
 *
 * Replaces the hand-rolled `.toggle-switch` / `.toggle-slider` CSS the wizard
 * used to ship. It stays a real `<input type="checkbox">` — visually hidden
 * rather than `display: none`, so it keeps its focus ring and stays reachable
 * by keyboard and screen readers — and the track and knob are drawn from its
 * checked state with `peer-checked:`.
 */
const ToggleSwitch = ({ checked, onChange, label, id }) => (
  <label
    htmlFor={id}
    className="inline-flex cursor-pointer items-center gap-2.5 select-none"
  >
    <span className="relative inline-flex shrink-0">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
      />
      <span className="block h-6 w-11 rounded-full bg-ink-300 transition peer-checked:bg-brand-600 peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-brand-600" />
      <span className="pointer-events-none absolute top-0.5 left-0.5 size-5 rounded-full bg-white shadow-sm transition-transform peer-checked:translate-x-5 motion-reduce:transition-none" />
    </span>
    <span className="text-fluid-sm text-ink-700">{label}</span>
  </label>
);

ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
};

export default ToggleSwitch;
